// ../../../node_modules/react-uid/dist/es2015/uid.js
var generateUID = function() {
  var counter2 = 1;
  var map = new WeakMap();
  var uid2 = function(item, index) {
    if (typeof item === "number" || typeof item === "string") {
      return index ? "idx-" + index : "val-" + item;
    }
    if (!map.has(item)) {
      map.set(item, counter2++);
      return uid2(item);
    }
    return "uid" + map.get(item);
  };
  return uid2;
};
var uid = generateUID();

// ../../../node_modules/react-uid/dist/es2015/Control.js
import {
  createElement
} from "react";

// ../../../node_modules/react-uid/dist/es2015/context.js
import {
  createContext
} from "react";
var createSource = function(prefix) {
  if (prefix === void 0) {
    prefix = "";
  }
  return {
    value: 1,
    prefix,
    uid: generateUID()
  };
};
var counter = createSource();
var source = createContext(createSource());
var getId = function(source2) {
  return source2.value++;
};
var getPrefix = function(source2) {
  return source2 ? source2.prefix : "";
};

// ../../../node_modules/react-uid/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || {__proto__: []} instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2)
      if (b2.hasOwnProperty(p))
        d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

// ../../../node_modules/react-uid/dist/es2015/UIDComponent.js
import {
  Component
} from "react";
var prefixId = function(id, prefix, name) {
  var uid2 = prefix + id;
  return String(name ? name(uid2) : uid2);
};
var UID = function(_super) {
  __extends(UID2, _super);
  function UID2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      quartz: _this.props.idSource || counter,
      prefix: getPrefix(_this.props.idSource),
      id: getId(_this.props.idSource || counter)
    };
    _this.uid = function(item) {
      return prefixId(_this.state.id + "-" + _this.state.quartz.uid(item), _this.state.prefix, _this.props.name);
    };
    return _this;
  }
  UID2.prototype.render = function() {
    var _a = this.props, children = _a.children, name = _a.name;
    var _b = this.state, id = _b.id, prefix = _b.prefix;
    return children(prefixId(id, prefix, name), this.uid);
  };
  return UID2;
}(Component);

// ../../../node_modules/react-uid/dist/es2015/Control.js
var UIDFork = function(_a) {
  var children = _a.children, _b = _a.prefix, prefix = _b === void 0 ? "" : _b;
  return createElement(UIDConsumer, null, function(id) {
    return createElement(source.Provider, {value: createSource(id + "-" + prefix)}, children);
  });
};
var UIDConsumer = function(_a) {
  var name = _a.name, children = _a.children;
  return createElement(source.Consumer, null, function(value) {
    return createElement(UID, {name, idSource: value, children});
  });
};

// ../../../node_modules/react-uid/dist/es2015/hooks.js
import * as React4 from "react";
var generateUID2 = function(context) {
  var quartz = context || counter;
  var prefix = getPrefix(quartz);
  var id = getId(quartz);
  var uid2 = prefix + id;
  var gen = function(item) {
    return uid2 + quartz.uid(item);
  };
  return {uid: uid2, gen};
};
var useUIDState = function() {
  if (true) {
    if (!("useContext" in React4)) {
      throw new Error("Hooks API requires React 16.8+");
    }
  }
  return React4.useState(generateUID2(React4.useContext(source)));
};
var useUID = function() {
  var uid2 = useUIDState()[0].uid;
  return uid2;
};
var useUIDSeed = function() {
  var gen = useUIDState()[0].gen;
  return gen;
};
export {
  UIDFork,
  uid,
  useUID,
  useUIDSeed
};
